import flowbiteInitializer from '@js/components/layouts/flowbite';
import * as Utils from '@js/modules/utils';
import {manageDrawer} from '@js/modules/drawer';

import TrackingManager from '@js/managers/trackingManager';
import UserManager from '@js/managers/userManager';
import BasketManager from '@js/managers/basketManager';
import TrialManager from '@js/managers/trialManager';
import ReviewManager from '@js/managers/reviewManager';
import initializeFavoriteMounts from '@js/managers/favoriteMounter';

import Notification from '@js/components/layouts/notification';
import {initializeConnection} from '@js/components/layouts/connection';

import RouteManager from '@js/modules/routeManager';
import AnalyticsService from '@js/modules/analyticsService';
import WebPerf from '@js/modules/webPerf';
import UsageTotals from '@js/modules/usageTotals';
import PWAManager from '@js/modules/pwaManager';
import initializePreventIosPageZoom from '@js/modules/preventIosPageZoom';

if (process.env.NODE_ENV === 'production') {
    require('@js/production');
} else {
    require('@js/development');
}

// Define settings and features
window.settings = JSON.parse(document.getElementById('settings')?.innerText || '{}');
window.features = JSON.parse(document.getElementById('features')?.innerText || '{}');
window.explorerFeatures = JSON.parse(document.getElementById('features-explorer')?.innerText || '{}');
window.freeFeatures = JSON.parse(document.getElementById('features-free')?.innerText || 'null') || window.features;
window.experiments = JSON.parse(document.getElementById('experiments')?.innerText || '{}');
window.bandits = JSON.parse(document.getElementById('bandits')?.innerText || '{}');
window.experimentParams = JSON.parse(document.getElementById('experiment-params')?.innerText || '{}');

// Check user and admin state
window.currentUserId ||= Utils.getCookie('user.connected_id');
window.currentAdminId ||= Utils.getCookie('admin.connected_id');

export default function InitializeLayout () {
    if (window.currentAdminId) {
        import('@js/managers/adminManager')
            .then(({default: AdminManager}) => {
                AdminManager.initialize();
            });
    }

    // Clean timestamp after connection
    Utils.clearForceReloadParam();

    // initialize components based on data attribute selectors
    flowbiteInitializer();

    manageDrawer('drawer-navigation', 'drawer-navigation-button', 'drawer-navigation-close');

    // Initialize notifications
    Notification.initialize();

    // Initialize connection modules
    initializeConnection();

    // Initialize routes
    RouteManager.initialize();

    // Tracking state management
    TrackingManager.initialize();

    // User management
    UserManager.initialize();

    // Basket management
    BasketManager.initialize();

    // Analytics
    AnalyticsService.initialize();

    // Real timings for Grafana (web-vitals fetched after load)
    WebPerf.initialize();

    // A visit's usage totals (engagement, routes, tiles), sent from time to time
    UsageTotals.initialize();

    // Tagged links and buttons of the server-rendered pages (data-track / data-usage)
    AnalyticsService.trackTaggedClicks();
    AnalyticsService.trackRestoredPages();

    // PWA manager
    PWAManager.initialize();

    // Prevent iOS Safari page zoom (pinch/double-tap) that hijacks map gestures
    initializePreventIosPageZoom();

    // Trial
    TrialManager.initialize();

    // Reviews
    ReviewManager.initialize();

    // Favorite buttons on server-rendered ride cards
    initializeFavoriteMounts();
}
